const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)',
        padding               : '5px 20px 20px 20px',
        maxWidth             : '600px'
    },
    overlay : {
        backgroundColor   : 'rgba(0, 0, 0, 0.6)'
    }
};

exports.customStyles = customStyles;